module.exports = __webpack_public_path__ + "static/media/maxSuccessionWins_60_70.e7bf38c6.png";